// frontend/src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/HomeView.vue'), meta: { requiresAuth: true } },
  { path: '/ship/:mmsi', name: 'ShipDetail', component: () => import('../views/ShipDetailView.vue'), meta: { requiresAuth: true } },
  { path: '/cameras', name: 'Cameras', component: () => import('../views/CamerasView.vue'), meta: { requiresAuth: true } },
  { path: '/playback', name: 'Playback', component: () => import('../views/PlaybackView.vue'), meta: { requiresAuth: true } },
  { path: '/stats', name: 'Statistics', component: () => import('../views/StatisticsView.vue'), meta: { requiresAuth: true } },
  { path: '/admin/config', name: 'AdminConfig', component: () => import('../views/AdminConfigView.vue'), meta: { requiresAuth: true, adminOnly: true } },
  { path: '/login', name: 'Login', component: () => import('../views/LoginView.vue'), meta: { requiresAuth: false } },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  // Cek token expiry sebelum navigasi
  if (authStore.isAuthenticated && authStore.checkTokenAndLogout) {
    authStore.checkTokenAndLogout()
  }
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/')
  } else if (to.meta.adminOnly && authStore.user?.role !== 'admin') {
    next('/')
  } else {
    next()
  }
})

export default router